import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-entreprises',
    templateUrl: './entreprises.component.html',
    styleUrls: ['./entreprises.component.scss']
})
export class EntreprisesComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();

    echartsIntance = null;
    user: User = Object.assign({}, EMPTY_USER);

    options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                animation: false
            },
            formatter: params => {
                let lib = params[0].name + '<br/>';
                params.forEach(d => {
                    lib += '<span style="font-size:24px;">• </span>' + d.seriesName + ' : ' + Math.round(d.data).toLocaleString('fr-FR');
                });
                return lib;
            }
        },
        legend: {
            orient: 'vertical',
            right: '40px',
            bottom: '70px',
            align: 'right',
        },
        grid: {
            left: '0%',
            right: '1%',
            top: '40px',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            data: [],
            axisTick: {
                alignWithLabel: true,
            },
        },

        yAxis: {
            type: 'value',
            label: {
                formatter: '{b} <br/>{a} : {c}',
            },
            min: 10000,
        },
        color: ['#2980B9'],

    };

    data = {
        series: [],
    };

    constructor(public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {
        Object.keys(this.favorite.ad_city.ets).forEach(keys => {
            if (this.options.yAxis.min > (this.favorite.ad_city.ets[keys] * 0.8)) {
                this.options.yAxis.min = Math.round(this.favorite.ad_city.ets[keys] * 0.8 / 50) * 50;
            }
        });

        if (this.favorite.ad_city.city_code === '') {
            return;
        }

        this.data = {
            series: [
                {
                    name: 'Nombre d\'entreprises',
                    type: 'line',
                    data: [this.favorite.ad_city.ets.ETNTOT11, this.favorite.ad_city.ets.ETNTOT12, this.favorite.ad_city.ets.ETNTOT13, this.favorite.ad_city.ets.ETNTOT14, this.favorite.ad_city.ets.ETNTOT15,
                        this.favorite.ad_city.ets.ETNTOT16, this.favorite.ad_city.ets.ETNTOT17, this.favorite.ad_city.ets.ETNTOT18, this.favorite.ad_city.ets.ETNTOT19, this.favorite.ad_city.ets.ETNTOT20, this.favorite.ad_city.ets.ETNTOT21]
                },
            ]
        };

        this.options.xAxis.data = ['2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021'];

        if (this.echartsIntance) {
            this.echartsIntance.setOption(this.options);
        }
    }

    onChartInit(ec) {
        this.echartsIntance = ec;
    }
}
